// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3sqaP","modalForm":"UpgradeEpcsModal_modalForm__3RkoI","modalFooter":"UpgradeEpcsModal_modalFooter__13TTs"};